<template>
  <div class="o-video" v-if="videoSrc">
    <div class="o-video__aspect">
      <div class="o-video__inner">
        <iframe :src="videoSrc" frameborder="0" allowfullscreen autoplay muted allow="autoplay"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-video',
  computed: {
    videoOpen () {
      return this.$store.state.videoOpen
    },
    videoSrc () {
      return this.$store.state.videoSrc
    }
  },
  watch: {
    videoOpen (val) {
      if (val === true) {
        document.body.classList.add('u-body-lock-scroll')
      } else {
        document.body.classList.remove('u-body-lock-scroll')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyVideo.vue